"use client"

import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { z } from "zod"
import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/Components/ui/form"
import { Input } from "@/Components/ui/input"

import { useContext, useEffect } from 'react'
import { PlanBuilderContext, Task } from './Plan'
import { NotebookTabs } from "lucide-react"
import React from "react"

interface FrmUpdateTaskNameProps {
    setDialogOpen?: (open: boolean) => void;
    tasks: Task[];
}

const formSchema = z.object({
    taskName: z.string()
        .min(1, "Task name is required")
        .max(50, "Task name cannot exceed 50 characters"),
})

const FrmUpdateTaskName = ({ setDialogOpen, tasks }: FrmUpdateTaskNameProps) => {
    const props = useContext(PlanBuilderContext);
    const [curTaskNum, setCurTaskNum] = React.useState(0);

    const { reset, ...form } = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            taskName: tasks[curTaskNum].name || "",
        },
    });

    React.useEffect(() => {
        setTimeout(() => {
            const input = document.querySelector('input[name="taskName"]') as HTMLInputElement | null;
            if (input) {
                input.focus();
                input.select();
            }
        }, 0);
    }, [reset, tasks]);

    useEffect(() => {
        reset({
            taskName: tasks[curTaskNum].name || "",
        });
        setTimeout(() => form.setFocus("taskName"), 0);
    }, [reset]);

    function onSubmit(data: z.infer<typeof formSchema>) {
        tasks[curTaskNum].name = data.taskName;
        props.updateTask(tasks[curTaskNum].id, tasks[curTaskNum]);

        if (curTaskNum < tasks.length - 1) {
            setCurTaskNum(curTaskNum + 1);
            reset({
                taskName: tasks[curTaskNum + 1].name || "",
            });
            setTimeout(() => {
                const input = document.querySelector('input[name="taskName"]') as HTMLInputElement | null;
                if (input) {
                    input.focus();
                    input.select();
                }
            }, 0);
        } else {
            setDialogOpen?.(false);
        }
    }

    return (
        <Form {...form} reset={reset}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
                <FormField
                    control={form.control}
                    name="taskName"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Name</FormLabel>
                            <FormControl>
                                <Input placeholder="" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <button type="submit" className="flex flex-row items-center button-default w-full"><NotebookTabs className="w-6 h-6 mr-2" />Update Task</button>
            </form>
        </Form>
    )
}

export default FrmUpdateTaskName